import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { alerts, features, queryClient as qc } from 'keys'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { actions } from "store"
import { bulkCreateByLevelFetch, getWatingToMarkingCountFetch, saveAssessmentFetch } from "store/middlewares/assessment.crud"
import { secretStorage } from "config"
import { useContext } from "react"
import { AbilityContext } from "components/Permissions/Can"

const useSaveAssessment = () => {
    const { assessment } = useSelector(state => state.assessment)

    return useMutation({
        mutationFn: (assessmentToSave) => saveAssessmentFetch({ assessmentID: assessment.id, assessment: assessmentToSave })
    })
}

const useWatingForMarkingCount = () => {
    const ability = useContext(AbilityContext)
    const canReadAdminAssessment = ability.can('read', features.admin_assessment)

    return useQuery({
        queryKey: [qc.watingForMarkingCount],
        queryFn: async () => {
            if (canReadAdminAssessment) {
                const { data } = await getWatingToMarkingCountFetch()
                return data
            }
            return null
        },
        enabled: !!canReadAdminAssessment,
        // enabled: false,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        refetchOnReconnect: true,
    })
}

const useBulkCreateByLevel = (testTakerID) => {
    const user = secretStorage.getUser()
    const dispatch = useDispatch()
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (test_taker_id) => bulkCreateByLevelFetch({ test_taker_id: testTakerID || test_taker_id }),
        onSuccess: () => {
            let userData = { ...user, balance: user.balance - 1 }
            secretStorage.setUser(userData)
            dispatch(actions.setUser(userData))
            dispatch(actions.setAlerts({
                key: alerts.createTestTaker,
                value: {
                    open: false,
                }
            }))
            queryClient.invalidateQueries({ queryKey: [qc.dashboard] })
        },
        onError: () => {
            dispatch(actions.setAlerts({
                key: alerts.createTestTaker,
                value: {
                    open: false
                }
            }))
            dispatch(actions.setAlerts({
                key: alerts.noBalance,
                value: {
                    open: true,
                    props:
                        testTakerID ? {
                            test_taker_id: testTakerID
                        } : null
                }
            }))
        }
    })
}

export default { useWatingForMarkingCount, useBulkCreateByLevel, useSaveAssessment }

